import styled from "styled-components";

export const StyledThreeDControlsViewContainer = styled.div`
  display: "inline";
`;
